/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HomePageFaqItem } from "@/types/homepage";

const HomePageFAQ = ({
  content,
}: {
  content: HomePageFaqItem[] | undefined;
}) => {
  const safeFaqs = (content ?? []).map((item) => {
    const question = item.question?.trim() ?? "";
    const normalizedQuestion = question.toLowerCase();

    if (normalizedQuestion.includes("apply without a consultant")) {
      return {
        ...item,
        question: "Do I need a consultant to apply?",
        answer:
          "You can search, check eligibility and apply on your own. Our counsellors are available if you want personal guidance.",
      };
    }

    return item;
  });

  return (
    <div>
      <div className="relative">
        <div className="container max-w-[1400px] mx-auto pb-[64px] sm:pb-[94px] md:pb-[100px] xl:pb-[120px] pt-[18px] md:pt-8 lg:pt-[96px] px-4 xxs:px-6 sm:px-[40px] relative z-20">
          <p
            className="text-center text-[22px] sm:text-3xl md:text-4xl lg:text-5xl font-semibold mb-3 md:mb-4 xl:mb-5"
          >
            Things you might be wondering about
          </p>
          <p
            className="text-center bg-gradient-to-r from-[#CD8EF1] to-[#62A4FA] bg-clip-text text-transparent font-semibold ff_poppins text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl"
          >
            FREQUENTLY ASKED QUESTIONS
          </p>
          <div className="mx-auto mt-[48px]" id="faq">
            <Accordion type="single" collapsible className="w-full">
              {safeFaqs.map((item, index) => (
                  <AccordionItem
                    key={index}
                    value={String(index)}
                    className="faq_parent"
                  >
                    <AccordionTrigger className="text-base md:text-[18px] xl:text-xl font-semibold text-[#383640]">
                      {item.question}
                    </AccordionTrigger>
                    <AccordionContent className="text-[#64636B] pb-6 text-sm sm:text-base xl:text-lg font-normal md:font-medium ff_poppins">
                      {item.answer}
                    </AccordionContent>
                  </AccordionItem>
                ))}
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
};
export default HomePageFAQ;
